/*
* We check on ckeditor element to check if a data-restriction is defined,
* We hide all restricted elements ([data-restricted]`) inside the data-restriction container
* if so we look if there is content with the data attribute equal to the role `[data-restricted="{role}"]`
* and if there is, we show these elements.
* */

window.addEventListener('DOMContentLoaded', () => {
  const restrictedCtn = document.querySelectorAll('[data-restriction]');
  const restrictedEls = document.querySelectorAll('[data-restricted]');

  if (restrictedEls) {
    restrictedEls.forEach(restrictedEl => {
      restrictedEl.dataset.initialDisplay = restrictedEl.style.display;
      // If an element inside the restricted container have the data-restricted data attribute, we initially hide it.
      restrictedEl.style.display = 'none';
    });
  }

  restrictedCtn.forEach(restrictedBlock => {
    const restriction = restrictedBlock.dataset.restriction;

    if (restrictedEls) {
      restrictedEls.forEach(restrictedEl => {
        // If there is a restriction, we need to show the hidden content if the current user have the right to see them
        if (restriction !== '') {
          const elRestriction = restrictedEl.dataset.restricted;
          if (elRestriction === restriction) {
            restrictedEl.style.display = restrictedEl.dataset.initialDisplay;
          }
        }
      });
    }
  });
});
